import styled from '@emotion/styled';
import { Tooltip } from 'antd';

export interface EllipsisTextProps {
  text: string;
  maxWidth: number;
}

const Text = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
`;

const EllipsisText = (props: EllipsisTextProps) => {
  const { text, maxWidth } = props;

  return (
    <Tooltip title={text}>
      <Text style={{ maxWidth }}>{text}</Text>
    </Tooltip>
  );
};

export default EllipsisText;
